<template>
  <v-card :class="`${elevation} d-flex flex-column align-stretch metric-box`">
    <v-card v-if="!hideTitle" :class="['pl-2', 'align-center']" :style="{backgroundColor: color}">
      <v-container class="align-center pa-2">
        <v-row class="align-center white--text pr-3 flex-nowrap">
          <v-icon class="align-center title-icon" color="primary">mdi-{{ icon }}</v-icon>
          <span class="pt-3 pl-2 subtitle-2 font-weight-black title-label" style="height: 45px;">
            <v-tooltip bottom v-model="labelTooltip" :open-on-hover="false" :open-on-focus="false">
              <template v-slot:activator="{ attrs }">
                <span ref="labelText" class="text-truncate" v-bind="attrs" @mouseenter="showLabelTooltip" @mouseleave="labelTooltip = false">{{ label }}</span>
              </template>
              {{ label }}
            </v-tooltip>
            <v-icon v-if="$slots['info-dialog']" small class="align-center" color="primary" @click.stop="infoDialog = true">mdi-information-outline</v-icon>
            <v-dialog v-model="infoDialog" max-width="600px" open-on-hover>
              <v-card>
                <v-card-title class="headline">
                  <v-icon class="align-center pr-2" color="primary">mdi-{{ icon }}</v-icon>{{ label }}
                </v-card-title>
                <v-card-text>
                  <slot name="info-dialog"></slot>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="red darken-1"
                    text
                    @click="infoDialog = false"
                  >
                    {{ $t('components.TextBox.close') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-tooltip bottom max-width="420" v-if="activeWarnings.length > 0">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="align-center" color="warning" v-bind="attrs" v-on="on">mdi-alert</v-icon>
              </template>
              <div v-for="(warning, index) in activeWarnings" :key="index" :class="index > 0 ? 'mt-2' : ''">{{ warning }}</div>
            </v-tooltip>
          </span>
          <v-spacer></v-spacer>
          <slot name="info"></slot>
        </v-row>
      </v-container>
    </v-card>
    <slot></slot>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    infoDialog: false,
    labelTooltip: false
  }),
  computed: {
    // Call sites build the list conditionally, so they can pass nulls for the
    // caveats that don't apply; only the real ones reach the icon.
    activeWarnings () {
      return this.warnings.filter(function (warning) { return !!warning })
    }
  },
  methods: {
    // The title never wraps: when it doesn't fit it is cut with an ellipsis, and
    // only then does hovering it show the full text.
    showLabelTooltip () {
      var el = this.$refs.labelText
      this.labelTooltip = !!el && el.scrollWidth > el.clientWidth
    }
  },
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'chart-bubble',
      required: false
    },
    color: {
      type: String,
      default: '#212121',
      required: false
    },
    hideTitle: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    },
    elevation: {
      type: String,
      required: false,
      default () {
        return 'elevation-2'
      }
    },
    // Caveats about the figure this box shows, surfaced as a warning icon beside
    // the title with the texts in its tooltip. Falsy entries are ignored.
    warnings: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style scoped>
.metric-box {
  min-height: 100px;
}
/* Keep the title on one line: it gives way before the controls beside it do */
.title-icon {
  flex-shrink: 0;
}
.title-label {
  display: flex;
  align-items: flex-start;
  min-width: 0;
  flex: 0 1000 auto;
}
.title-label > .text-truncate {
  min-width: 0;
}
.title-label > .v-icon {
  flex-shrink: 0;
  height: 22px;
  margin-left: 4px;
}
</style>
